module.exports = __webpack_public_path__ + "img/hand-isanon.66b0a9aa.png";